// @snippet
/**
 * @class CopyToClipboard
 */

import Notification from '../helpers/Notification';

const copyTriggerSelector = '[data-copy-to-clipboard]';

export default class CopyToClipboard {
  constructor() {
    this.copyToClipboard = this.copyToClipboard.bind(this);
    window.copyToClipboard = this.copyToClipboard;
    this.init();
  }
  init() {
    const area = document.querySelector('body');
    area.addEventListener('click', (event) => {
      const item = event.target.closest(copyTriggerSelector);

      if (item) {
        this.copyToClipboard({ currentTarget: item });
      }
    });
  }

  copyToClipboard({ currentTarget }) {
    const value =
      currentTarget?.dataset?.value || currentTarget.innerText || null;
    if (value) {
      const text = currentTarget?.dataset?.text
        ? currentTarget.dataset.text.replace('#value#', value)
        : `Copied to clipboard: ${value}`;
      const el = document.createElement('textarea');
      el.value = value;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');

      if (Notification) {
        Notification.mark('success', text);
      }

      if (el) {
        el?.remove();
      }
      // document.body.removeChild(el);
    }
  }
}
